import { connect } from 'react-redux';
import ArticlePreview from '../articlePreview';
import createArticleProps from '../../../utils/connections/createArticleProps';

const mapStateToProps = (state, ownProps) => {
  const { panel: { launchProps: { type, index = 0 } } } = ownProps;
  const { connections: { data } } = state;
  const connectionsEntry = data[type][index];

  return createArticleProps(connectionsEntry);
};

export default connect(mapStateToProps)(ArticlePreview);
